import {
  AiFillEye,
  AiOutlineEye,
  AiOutlineKey,
  AiOutlineUser,
  AiOutlineEyeInvisible,
} from "react-icons/ai";
import ChanelsLogo from "../../../assets/svg/chanels-logo.svg";

import { Button } from "../../../components/Button";
import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import { getToken, setToken } from "../../../utils/token";
import axios from "axios";
import BGImg from "../../../assets/png/v300batch2-nunoon-13.jpg";
import { headers } from "../../../utils/headers";
import { isWWWhostname } from "../../../utils/helpers";
import { apiURL } from "../../../utils/axios";
import { notification } from "antd";
const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const queryUser = searchParams.get("username");
  const [newPassword, setNewPassword] = useState("");
  const [username, setUsername] = useState(queryUser || "");
  const [password, setPassword] = useState("");
  const [subdomain, setSubdomain] = useState("we");
  const [loading, setLoading] = useState(false);
  const [eye1, setEye1] = useState(false);
  const [eye, setEye] = useState(false);
  let navigate = useNavigate();
  const handleReset = async () => {
    try {
      if (!newPassword || !password || !username) {
        toast.error("All values are required");
        return;
      }
      setLoading(true);
      let res = await axios.post(
        (isWWWhostname() === "xyz" ? apiURL.mmsUrlStaging : apiURL.mmsUrlDev) +
          "auth/resetdefaultpassword",
        {
          username,
          password,
          newpassword: newPassword,
          subdomain: isWWWhostname(),
        },
        headers
      );
      if (res.data.response == "failure") {
        toast.error("Operation failed. Please try again.");
        setLoading(false);
        return;
      }
      await setToken("spiral_token", res.data.sessionid);
      await setToken("spiral_username", username);
      // console.log(res.data);
      if (!res.data?.registration) {
        notification.success({
          message: "One more step to go",
          description: "Please complete your registration",
        });
        setLoading(false);
        await setToken("spiral_registration", 0);
        navigate("/completeregistration");
        return;
      }
      if (res.data?.registration) {
        setLoading(false);
        await setToken("spiral_registration", 1);
        navigate("/userroles");
        return;
      }
    } catch (err) {
      toast.error(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="h-screen w-screen h-100 flex flex-row items-center justify-center">
      <div
        className="h-screen absolute top-0 left-0 w-screen"
        style={{
          background: `url(${BGImg})`,
          backgroundPosition: "center",
          backgroundRepeat: "center",
          backgroundSize: "cover",
          opacity: 0.1,
          backgroundAttachment: "fixed",
        }}
      ></div>
      <div className="">
        <div className="bg-white w-[95%px] md:w-[500px] h-auto drop-shadow-md rounded-md p-6">
          {/* Logo */}
          <div className="flex flex-col items-center justify-center">
            <div className="flex w-24 h-24 overflow-hidden">
              <img
                src={ChanelsLogo}
                alt="Chanels Logo"
                className="h-full scale-150 w-full object-cover"
              />
            </div>
          </div>
          {/* Title */}
          <div className="text-center text-primary font-semibold text-2xl pb-4">
            Chanels
          </div>
          <div className="font-normal text-center text-[14px]">
            Reset your default password to continue.
          </div>
          <hr className="my-4" />
          <div className="w-100">
            {/* Username */}
            <div className="mt-6">
              <div className="bg-gray-50 flex items-center justify-between w-100 border-[1px] rounded border-gray-200 mt-2 h-[45px]">
                <div className="flex ">
                  <div className="d-inline flex items-center justify-center px-2">
                    <AiOutlineUser
                      color="text-primary"
                      className="text-gray-500"
                    />
                  </div>
                  <div className="ml-2">
                    <input
                      required
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      type={"text"}
                      placeholder={"Enter your username"}
                      className="bg-transparent w-full placeholder:text-sm placeholder:font-normal outline-none border-[0px]"
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* Default password */}
            <div className="mt-6">
              <div className="bg-gray-50 flex items-center justify-between w-100 border-[1px] rounded border-gray-200 mt-2 h-[45px]">
                <div className="flex ">
                  <div className="d-inline flex items-center justify-center px-2">
                    <AiOutlineKey
                      color="text-primary"
                      className="text-primary"
                    />
                  </div>
                  <div className="ml-2">
                    <input
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      type={eye ? "text" : "password"}
                      placeholder={"Enter your old password"}
                      className="bg-transparent w-full placeholder:text-sm placeholder:font-normal outline-none border-[0px]"
                    />
                  </div>
                </div>

                <div
                  className="px-3 cursor-pointer"
                  onClick={() => setEye(!eye)}
                >
                  {eye ? (
                    <AiOutlineEye
                      color="text-primary"
                      className="text-gray-500"
                    />
                  ) : (
                    <AiOutlineEyeInvisible
                      color="text-gray-500"
                      size={20}
                      className="text-gray-500"
                    />
                  )}
                </div>
              </div>
            </div>
            {/* New Password */}
            <div className="mt-6">
              <div className="flex items-center justify-between w-100 border-[1px] rounded bg-gray-50 border-gray-200 mt-2 h-[45px]">
                <div className="flex w-full">
                  <div className="d-inline flex items-center justify-center px-2">
                    <AiOutlineKey
                      color="text-gray-500"
                      size={20}
                      className="text-gray-500"
                    />
                  </div>
                  <input
                    required
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    type={eye1 ? "text" : "password"}
                    placeholder={"Enter your new password"}
                    className="bg-transparent ml-2 w-full placeholder:text-sm placeholder:font-normal outline-none border-[0px]"
                  />
                </div>
                <div
                  className="px-3 cursor-pointer"
                  onClick={() => setEye1(!eye1)}
                >
                  {eye1 ? (
                    <AiOutlineEye
                      color="text-gray-500"
                      size={20}
                      className="text-gray-500"
                    />
                  ) : (
                    <AiOutlineEyeInvisible
                      color="text-primary"
                      size={20}
                      className="text-gray-500"
                    />
                  )}
                </div>
              </div>
            </div>
            {/* Button */}
            <div className=" w-100 mt-7">
              <Button
                text={"Continue"}
                loading={loading}
                onClick={handleReset}
              />
            </div>

            <div className="w-100 mt-4 ">
              <div className="text-primary block w-100 text-center font-normal py-3">
                {/*  Need help with you account? */}
              </div>
              <Link
                to="/"
                className="underline w-100 block cursor-pointer text-sm text-secondary text-center"
              >
                Already have an account? Log in.
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
